import { RFXTypes } from 'data/BusinessConstants';

const urls = {
  landing: '/',
  apps: {
    offers: '/offers'
  },
  pages: {
    smart: '/smart',
    dashboard: '/dashboard',
    createrequest: '/createrequest',
    createrfi: '/createrfi',
    editrfi: '/edit',
    clonerequest: '/clonerequest',
    editround: '/editround',
    initiateround: '/initiateround',
    editresponse: '/editresponse',
    initiateresponse: '/initiateresponse',
    view: '/view',
    compare: '/compare',
    offer: '/offer',
    buyer: '/buyer',
    supplier: '/supplier',
    notifications: '/notifications',
    postaward: '/postaward',
    rfi: '/rfi',
    clonerfi: '/clonerfi',
    changeorder: '/changeorder',
    create:'/create'
  },
  SIM_TICKET_URL: 'https://t.corp.amazon.com/create/templates/7a83e1e5-8a95-4d0f-837a-52d6f144b898'
};

export const rumPaths = {
  smart: '/smart',
  landing: '/',
  unauthorized: '/unauthorized',

  postaward: '/buyer/postaward/:rfxId/:revision?',
  buyer_dashboard: '/buyer/dashboard',
  buyer_view: '/buyer/view/:rfxId',
  compare_rfx: '/buyer/compare/:rfxId:/revision?',
  offer_rfx: '/buyer/offer/:rfxId/:revision?',
  edit_round: '/buyer/view/:rfxId/editround',
  initiate_round: '/buyer/view/:rfxId/initiateround',
  create_request: '/buyer/createrequest',
  clone_request: '/buyer/clonerequest',

  create_rfi: '/buyer/createrfi',
  buyer_view_rfi: '/buyer/view/rfi/:rfxId',
  edit_rfi: '/buyer/view/rfi/:rfxId/edit',
  clone_rfi: '/buyer/clonerfi',

  supplier_dashboard: '/supplier/dashboard',
  supplier_view: '/supplier/view/:rfxId',
  edit_response: '/supplier/view/:rfxId/editresponse',
  initiate_response: '/supplier/view/:rfxId/initiateresponse',
  supplier_view_rfi: '/supplier/view/rfi/:rfxId',

  change_order_create: '/changeorder/create',
  change_order_view: '/changeorder/view/:coId',

  notifications: '/notifications',
}

/**
 * Get URL for the RFX detail view page with optional action
 *
 * @param rfxId - the ID of the RFX that buyer wants to view
 *        rfxType - RFQ or RFI
 *        action - optional, actions such as "edit", "editround"
 * @returns URL for the RFX detail view
 */
export function getBuyerRFXDetailViewUrl({
  rfxId,
  rfxType,
  action
}: {
  rfxId: string;
  rfxType: string;
  action?: 'edit';
}) {
  const { smart, buyer, view, rfi } = urls.pages;
  const rfiUrl = rfxType === RFXTypes.RFQ ? '' : rfi;
  const actionUrl = action === undefined ? '' : `/${action}`;
  return `${buyer}${view}${rfiUrl}/${rfxId}${actionUrl}`;
}

export default urls;
